export default "__VITE_ASSET__CN4FQCwp__"